import { Button, CircularProgress, Dialog, DialogActions, DialogContent } from '@mui/material';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useUserApi } from '../../services/api/useUser.api';
import { EulaContent } from './EulaContent';

export function EulaDialog() {
  const queryClient = useQueryClient();
  const { getUserInfo, updateUser } = useUserApi();
  const [eulaError, setEulaError] = useState<Error | null>(null);
  const [eulaLoading, setEulaLoading] = useState(false);

  const { data: user } = useQuery({
    queryKey: ['userInfo'],
    queryFn: getUserInfo,
  });

  const { mutate: acceptEulaMutation, isPending } = useMutation({
    mutationKey: ['acceptEula'],
    mutationFn: () => updateUser(user!.id, { eula_accepted: true }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['userInfo'], exact: false });
    },
  });

  const open = Boolean(user && user.eula_accepted === false);
  if (!open) return null;

  return (
    <Dialog open={open} sx={{ zIndex: 99999 }} maxWidth='sm' fullWidth>
      <DialogContent>
        <EulaContent onError={setEulaError} onLoading={setEulaLoading} />
      </DialogContent>
      <DialogActions>
        <Button
          disableElevation
          variant='contained'
          onClick={() => acceptEulaMutation()}
          disabled={isPending || Boolean(eulaError) || eulaLoading}
        >
          {isPending ? <CircularProgress size={24} /> : 'ACCEPT'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EulaDialog;
